/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "../FluxCommon/Actions", "../FluxCommon/ActionsHubManager", "./PodsActions"], function (require, exports, Actions_1, ActionsHubManager_1, PodsActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsActionsCreator = /** @class */ (function (_super) {
        __extends(PodsActionsCreator, _super);
        function PodsActionsCreator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PodsActionsCreator.getKey = function () {
            return "pods-actionscreator";
        };
        PodsActionsCreator.prototype.initialize = function (instanceId) {
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(PodsActions_1.PodsActions);
        };
        PodsActionsCreator.prototype.getPods = function (kubeService, labelSelector, fetchByLabel) {
            var _this = this;
            if (fetchByLabel === void 0) { fetchByLabel = false; }
            if (fetchByLabel && !labelSelector) {
                // For service's associated pods, fetchByLabel is true; In this scenario if no label selector is supplied, it implies zero pods
                var podList_1 = {
                    apiVersion: "",
                    items: [],
                    kind: "",
                    metadata: {}
                };
                // Calling action inside timeout to ensure the action listener is initialized in the ServiceDetails
                setTimeout(function () { return _this._actions.podsFetchedByLabel.invoke({ podsList: podList_1, labelSelector: "", isLoading: false }); });
            }
            else {
                kubeService && kubeService.getPods(labelSelector || undefined).then(function (podList) {
                    _this._extendPodMetadataInList(podList);
                    if (labelSelector) {
                        _this._actions.podsFetchedByLabel.invoke({ podsList: podList, labelSelector: labelSelector, isLoading: false });
                    }
                    else {
                        _this._actions.podsFetched.invoke({ podsList: podList, isLoading: false });
                    }
                });
            }
        };
        // getPod() will provide apiVersion for pod also, should we call?
        PodsActionsCreator.prototype._extendPodMetadataInList = function (podList) {
            var pods = podList && podList.items || [];
            var podsCount = pods.length;
            for (var i = 0; i < podsCount; i++) {
                var pod = podList.items[i];
                podList.items[i] = __assign({ apiVersion: pod.apiVersion || podList.apiVersion, kind: pod.kind || "Pod" }, pod);
            }
        };
        return PodsActionsCreator;
    }(Actions_1.ActionCreatorBase));
    exports.PodsActionsCreator = PodsActionsCreator;
});
